module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Inspire",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M30.15625,50.2492522 C30.15625,48.5146611 30.15625,43.2490856 28.375,41.2761715 C24.8404251,37.3612731 21.25,34.0405845 21.25,28.7138584 C21.25,20.7847454 27.6299423,14.3569292 35.5,14.3569292 C43.3700577,14.3569292 49.75,20.7847454 49.75,28.7138584 C49.75,34.020884 46.1737343,37.4228803 42.625,41.2761715 C40.84375,43.2102906 40.84375,48.5479596 40.84375,50.2492522 C39.0314064,50.2492522 31.9014053,50.2492522 30.15625,50.2492522 Z M30.15625,52.8215354 L40.84375,52.8215354 C40.8170052,57.6071785 40.2223854,60 39.0598907,60 C37.3161488,60 33.71875,60 31.9375,60 C30.75,60 30.15625,57.6071785 30.15625,52.8215354 Z M7,28.7138584 L15.90625,28.7138584 L15.90625,32.3030907 L7,32.3030907 L7,28.7138584 Z M33.71875,0 L37.28125,0 L37.28125,8.97308076 L33.71875,8.97308076 L33.71875,0 Z M58.0885829,9.6737432 L59.8698329,12.7589587 L52.0989171,17.2454991 L50.3176671,14.1602836 L58.0885829,9.6737432 Z M12.9114171,9.6737432 L20.6823329,14.1602836 L18.9010829,17.2454991 L11.1301671,12.7589587 L12.9114171,9.6737432 Z M55.09375,28.7138584 L64,28.7138584 L64,32.3030907 L55.09375,32.3030907 L55.09375,28.7138584 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c5bd3e7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/svg/inspire.vue
// module id = 636
// module chunks = 1